import { Select } from '@smartgift/frontend-toolkit';
import React, { useState, useEffect } from 'react';

import * as S from './style';

function TableSelectFilter({
  tableRef,
  placeholder = 'Filter',
  onChange = () => {},
  options,
  selectedOption,
  isMulti = true,
  ...props
}) {
  const [selectedOptions, setSelectedOptions] = useState(selectedOption ? selectedOption : []);

  useEffect(() => {
    setSelectedOptions(selectedOption);
  }, [selectedOption]);

  return (
    <S.CustomSelectWrapper>
      <Select
        menuPortalTarget={tableRef}
        size="sm"
        menuWidth="320px"
        value={selectedOptions}
        placeholder={placeholder}
        options={options}
        closeMenuOnSelect={false}
        showSelectedOptionInPlaceholder={false}
        onChange={e => {
          setSelectedOptions(e);
        }}
        hasMenuSearch={props.hasMenuSearch}
        isMulti={isMulti}
        onCancel={() => {
          props?.onMenuClose?.([]);
        }}
        onApply={() => {
          if (onChange) onChange(selectedOptions);
          props?.onMenuClose?.(selectedOptions);
        }}
        styles={{
          menuPortal: () => ({ zIndex: 999 })
        }}
        searchPlaceholder={props.searchPlaceholder}
        {...props}
      />
    </S.CustomSelectWrapper>
  );
}

export { TableSelectFilter };
